import {
  createPaginatedRpcSupabaseQuery,
  createRpcQuery,
  createSearchRpcSupabaseQuery,
  spawnCreateApiFunction,
  spawnDeleteApiFunction,
  spawnGetApiFunction,
  spawnListInApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
} from "@/utils/api";

import type {
  GetPaginatedManufacturersProps,
  GetSearchManufacturersProps,
  PaginatedManufacturer,
} from "@/api/resources/manufacturers/types";

const table = "manufacturers";
const query = `*`;
export const apiConfigManufacturers: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["name", "slug"],
  sortables: ["name", "slug", "created_at", "updated_at"],
};

export const getManufacturer = spawnGetApiFunction({ table, query });
export const getManufacturersByIds = spawnListInApiFunction({ table, query });
export const createManufacturer = spawnCreateApiFunction({ table, query });
export const updateManufacturer = spawnUpdateApiFunction({ table, query });
export const deleteManufacturer = spawnDeleteApiFunction({ table });

export const getPaginatedManufacturers = async ({
  workspace_ids,
  dataTableOptions,
  customFilters,
  customOrFilters,
}: GetPaginatedManufacturersProps) => {
  const { data, count, error } = await createPaginatedRpcSupabaseQuery<"get_manufacturers">({
    baseOptions: {
      rpcQuery: createRpcQuery(
        "get_manufacturers",
        {
          _workspace_ids: workspace_ids,
        },
        { count: "estimated" },
      ),
      searchables: apiConfigManufacturers.searchables,
      sortables: apiConfigManufacturers.sortables,
    },
    customFilters,
    customOrFilters,
    dataTableOptions,
  });
  if (error) throw error;
  const _data = data as PaginatedManufacturer[] | null;
  return { data: _data, count };
};

export async function getManufacturersBySearch({
  workspace_ids,
  searchOptions,
  customFilters,
  customOrFilters,
  limit,
}: GetSearchManufacturersProps) {
  const { data, count, error } = await createSearchRpcSupabaseQuery<"get_manufacturers">({
    baseOptions: {
      rpcQuery: createRpcQuery("get_manufacturers", { _workspace_ids: workspace_ids }, { count: "exact" }),
      searchables: apiConfigManufacturers.searchables,
      sortables: apiConfigManufacturers.sortables,
    },
    searchOptions,
    customFilters,
    customOrFilters,
    limit,
  });

  if (error) throw error;
  const _data = data as PaginatedManufacturer[] | null;
  return { data: _data, count };
}
